import { t } from '@lingui/core/macro';
import { Box, Menu, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function CreateProjectMenuItem(props) {
    const { name, onClick } = props;
    return (<Menu.Item onClick={onClick}>
      <Box alignItems="center" gap="sm">
        <Box alignItems="center" gap="md">
          <Falcon icon="plus"/>
          <Typography $appearance="300" $fontSize="small" $lineHeight="neutralized">
            {t({ comment: 'Create new project menu item title', message: 'Create new project:' })}
          </Typography>
        </Box>
        <Typography $appearance="100" $fontSize="small" $fontStyle="italic" $lineHeight="neutralized">
          {name}
        </Typography>
      </Box>
    </Menu.Item>);
}
